/**
 * 「AI 利用」画面の数字の書き方（Screen Contract `admin-ops-ai-usage`・Slack 日次レポートと同一）。
 */

/** USD: 小数 2 桁、非ゼロで $0.01 未満は `< $0.01`、本当に 0 のときだけ `$0.00`。 */
export function formatUsd(v: number): string {
  if (v > 0 && v < 0.01) return '< $0.01';
  return `$${v.toFixed(2)}`;
}

/** 1 件あたり: 小数 4 桁。 */
export const formatPerCall = (v: number) => `$${v.toFixed(4)}`;

/** 円（約）: 3 桁区切り。0 ではない 1 円未満は `約 ¥1 未満`（0 円に見せない・State Matrix P5）。 */
export function formatJpy(v: number): string {
  if (v > 0 && v < 1) return '約 ¥1 未満';
  return `約 ¥${Math.round(v).toLocaleString('ja-JP')}`;
}

/** トークンの合計タイル: `0.61M`。本当に 0 のときは `0`（State Matrix D2）。 */
export const formatMTok = (n: number) => (n === 0 ? '0' : `${(n / 1_000_000).toFixed(2)}M`);

/** 3 桁区切りの整数。 */
export const formatInt = (n: number) => n.toLocaleString('en-US');

/** JST の日付（YYYY-MM-DD）と時刻（HH:mm）。 */
const JST_OFFSET_MS = 9 * 3_600_000;
export const jstDate = (iso: string, deltaMs = 0) =>
  new Date(new Date(iso).getTime() + deltaMs + JST_OFFSET_MS).toISOString().slice(0, 10);
export const jstTime = (iso: string) =>
  new Date(new Date(iso).getTime() + JST_OFFSET_MS).toISOString().slice(11, 16);

/** 金額の欄: 全件が単価未登録なら `単価未登録`（`$0.00` / `—` / 空欄にしない・U-8）。 */
export function costCell(a: { calls: number; unpricedCalls: number; costUsd: number }): string {
  if (a.calls > 0 && a.unpricedCalls === a.calls) return '単価未登録';
  return formatUsd(a.costUsd);
}

/** 1 件あたりの欄（単価のある呼び出しだけで割る）。 */
export function perCallCell(a: { calls: number; unpricedCalls: number; costUsd: number }): string {
  const priced = a.calls - a.unpricedCalls;
  if (a.calls > 0 && priced === 0) return '単価未登録';
  if (priced <= 0) return '—';
  return formatPerCall(a.costUsd / priced);
}
